module.exports = __webpack_public_path__ + "static/DINPro-1b526b4182a1045647530d7aae7adc17.woff2";